<template>
  <div class="footer">
    <!-- 底部备案信息等 -->
    <div class="copyright">
      <a href="https://beian.miit.gov.cn/">
        Copyright © 2019
      </a>

    </div>

    <div class="footerName">
      <a href="https://beian.miit.gov.cn/">
      |
      </a>
    </div>

    <div class="lawyer">
      <a href="https://beian.miit.gov.cn/">
        {{ lawyerMsg }}
      </a>

    </div>
  </div>
</template>

<script>
export default {
  name: 'footer',
  data() {
    return {
      lawyerMsg: '蜀ICP备20002299号',
    }
  },
}
</script>

<style scoped>
.footer {
  width: 100%;
  height: 100%;
  flex-grow: 1;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  color: gray;
}
.footer a {
  text-decoration: none;
  color: gray;
}
.copyright {
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.footerName {
  width: 1%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lawyer {
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue